import { ConsultantsDTO } from "../../api/Consultation/GetAllConsultants"
import Placeholder from "../../assets/DrMohamedIsmael.png";
import Button from "../Shared/Button";

const PublicConsultantCard = ({ consultant, handleOpenModal }: { consultant: ConsultantsDTO, handleOpenModal: (consultant: ConsultantsDTO) => void }) => {
    return (
        <div className="relative" >
            <div
                className={`py-1.5 w-[120px] text-center rounded-tr-xl rounded-bl-xl absolute top-5 text-white font-semibold ${consultant.consultantDates.some((date) => date.isAvailable)
                    ? "bg-[#00DE7E]"
                    : "bg-[#FF0000]"
                    }`}
            >
                {consultant.consultantDates.some((date) => date.isAvailable)
                    ? "Available"
                    : "Not Available"}
            </div>
            <img
                className="h-[320px] mb-4 rounded-md w-full object-cover"
                src={consultant.img_url || Placeholder}
                alt={consultant.name}
            />
            <div className="text-center mb-3">
                <h1 className="text-[22px] font-semibold">{consultant.name}</h1>
                <p className="text-secondary">{consultant.title}</p>
            </div>
            <Button
                onClick={() => handleOpenModal(consultant)}
                variant="primary"
                className="!bg-[#3D50F8] hover:!bg-[#1a2159] !h-[42px] !text-base w-full"
            >
                Schedule a session
            </Button>
        </div>
    )
}

export default PublicConsultantCard